import { useEffect, useRef } from 'react';
import { useResizeObserver } from '../../../hooks/useResizeObserver.ts';
import { trpc } from '../../../utils/trpc/trpc.ts';
import { drawReportGraph } from '../drawReportGraph.ts';
import { ReportGraphContainer } from '../reportGraphContainer.tsx';
import { ReportSettings } from '../report-settings/reportSettings.ts';
import { prepareConfirmedScraps } from './prepareConfirmedScraps.ts';


interface Props {
    style?: React.CSSProperties;
    reportSettings: ReportSettings;
    operatorFooterLabelsByPeriod?: string[][];
    onOperatorFooterClick?: (periodIndex: number) => void;
}

export function ConfirmedScrapsGraph({
    style,
    reportSettings,
    operatorFooterLabelsByPeriod,
    onOperatorFooterClick,
}: Props) {
    const graphContainerRef = useRef<HTMLDivElement>(null);
    const dimensions = useResizeObserver(graphContainerRef);


    const { data: scrapCloseOperations, isFetching } = trpc.operations.get.useQuery({
        hasScrapCloseForm: true,
        effectiveTime: { start: reportSettings.first.start, end: reportSettings.last.end, },
    }, { refetchOnWindowFocus: false, });

    useEffect(() => {
        if (graphContainerRef.current == null || scrapCloseOperations == null) {
            return;
        }

        const data = prepareConfirmedScraps(scrapCloseOperations, reportSettings.periodsInRange);
        drawReportGraph(graphContainerRef.current!, data, operatorFooterLabelsByPeriod, onOperatorFooterClick);
    }, [graphContainerRef, scrapCloseOperations, reportSettings, operatorFooterLabelsByPeriod, onOperatorFooterClick, dimensions]);


    return (
        <ReportGraphContainer
            style={{ ...style, height: '100%' }}
            containerRef={graphContainerRef}
            isLoading={isFetching}
        />
    );
}
